import { Avatar } from 'src/components/atoms';
import { User } from 'src/types';
import { getInitials } from 'src/utils/getInitials';
import {
  GroupMemberDetails,
  GroupMemberItemContainer,
  GroupMemberName,
  GroupMemberRole,
} from './GroupMembers.styles';

interface Props {
  member: User;
  'data-testid'?: string;
}

export const GroupMemberItem = ({ member, ...props }: Props) => {
  const displayName = member.displayName ?? member.name;

  return (
    <GroupMemberItemContainer {...props}>
      <Avatar
        variant="text"
        size="medium"
        text={getInitials(displayName)}
        data-testid={`${props['data-testid']}-avatar`}
      />
      <GroupMemberDetails>
        <GroupMemberName data-testid={`${props['data-testid']}-name`}>
          {displayName}
        </GroupMemberName>
        <GroupMemberRole data-testid={`${props['data-testid']}-role`}>
          {member.role}
        </GroupMemberRole>
      </GroupMemberDetails>
    </GroupMemberItemContainer>
  );
};
